import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const GoogleSuccess = ({ onSuccess }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false); // Evita que se ejecute dos veces en StrictMode

  useEffect(() => {
    if (hasProcessed.current) return;

    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (token) {
      hasProcessed.current = true;

      // Recolectamos todos los datos que vienen del backend
      const userData = {
        token,
        username: params.get('username'),
        role:     params.get('role'),
        userId:   params.get('userId'),
        nombre:   params.get('nombre'),
        apellido: params.get('apellido'),
        email:    params.get('email')
      };

      const redirectTo = params.get('redirect');

      // 1. Guardamos en el estado global/localStorage
      onSuccess(userData);

      // 2. Pequeño delay para asegurar que el estado se procese antes del salto
      setTimeout(() => {
        navigate(redirectTo || '/dashboard', { replace: true });
      }, 100);
      
    } else {
      navigate('/login', { replace: true });
    }
  }, [location, navigate, onSuccess]);

  return (
    <div style={{ textAlign: 'center', marginTop: '100px', fontFamily: 'sans-serif' }}>
      <h2>¡Autenticación exitosa!</h2>
      <p>Redirigiendo a Edeli Store...</p>
    </div>
  );
};

export default GoogleSuccess;